import { useMemo } from "react";
import { ListGroupItem } from "react-bootstrap";
import { Link } from "react-router-dom";
import Loading from "../Loading";
import InsightFailed from "./InsightFailed";
import { useQueryAccountCashSettings } from "../cash/lib";
import { noCashTarget } from "./insightRegistry";

const UnassignedCashSettings = () => {
  // Every page of `GET /v1/cash-settings/accounts?requireBalance=true`
  // (APP-1651): the tile counts the whole filtered set.
  const { isPending: isPendingCashSettings, data: dataCashSettings } =
    useQueryAccountCashSettings({ requireBalance: true });
  const cashSettings = dataCashSettings?.data;

  const accountIdsWithoutCashTarget = useMemo(
    () =>
      (cashSettings ?? [])
        .filter(noCashTarget)
        .map((account) => account.accountId),
    [cashSettings],
  );

  return isPendingCashSettings ? (
    <ListGroupItem>
      <Loading />
    </ListGroupItem>
  ) : typeof cashSettings === "undefined" ? (
    <InsightFailed />
  ) : (
    <ListGroupItem>
      You have{" "}
      {accountIdsWithoutCashTarget.length <= 0 ? (
        "0 Accounts with AUM"
      ) : (
        <Link to="/clients/accounts?insight=accounts-missing-cash-target">
          {accountIdsWithoutCashTarget.length} Accounts with AUM
        </Link>
      )}{" "}
      that do not have a Cash Target assigned.
    </ListGroupItem>
  );
};

export default UnassignedCashSettings;
